import { render, staticRenderFns } from "./role-edit.vue?vue&type=template&id=2e74fc9c&scoped=true&"
import script from "./role-edit.vue?vue&type=script&lang=js&"
export * from "./role-edit.vue?vue&type=script&lang=js&"
import style0 from "./role-edit.vue?vue&type=style&index=0&id=2e74fc9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e74fc9c",
  null
  
)

export default component.exports